export const BreakpointBehavior = (superClass) => class extends superClass {
  firstUpdated(changedProperties) {
    super.firstUpdated(changedProperties);
    if (this.hasAttribute('unresolved')) {
      this.removeAttribute('unresolved');
      this.dispatchEvent(new CustomEvent('fit-resolved', { bubbles: true, composed: true }));
    }
  }
};
